import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { UploadProvider } from 'context'
import StyledAdminWrapper from './StyledAdminWrapper'

const LiveInstructor = React.lazy(() =>
  import(
    /* webpackChunkName: 'admin-live-instructor-show' */ 'components_v2/Admin/LiveInstructors/Show'
  )
)

export const StyledLiveInstructor = ({ liveInstructor }) => {
  return (
    <StyledAdminWrapper>
      <Suspense fallback=''>
        <UploadProvider>
          <LiveInstructor initialValues={liveInstructor} />
        </UploadProvider>
      </Suspense>
    </StyledAdminWrapper>
  )
}

StyledLiveInstructor.propTypes = {
  liveInstructor: PropTypes.object
}

export default StyledLiveInstructor
